module.exports = __webpack_public_path__ + "img/image31.e4a9e2e4.png";